export default "__VITE_ASSET__BXpV7jbB__"